
import React from 'react';
import './Plasticproduct.css';
import Plasticprod from '../../../imgs/Plasticprod.webp';

const Plasticproduct = () => {
    return (
        <div className="Bulbhous-wrapper">
            <h2>Product Information</h2>
            <div className="Bulbhous-card">
                <img src={Plasticprod} alt="Application" className="Bulbhous-img" />
            </div>
        </div>
    );
};

export default Plasticproduct;
